
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./H2SStripper.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { LineChart } from "lucide-react";
import StrippingEfficiencyChart from "../components/StrippingEfficiencyChart";
import StrippingMultivariableTrendChart from "../components/StrippingMultivariableTrendChart";

import { trackPageVisit } from "../competency/PageTracker";





 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function H2SStripper() {

        useEffect(() => {
  
    trackPageVisit("H2SStripper");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  FCV_2901: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2902: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2903: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("H2SStripper_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2901: { ...DEFAULT_VALVES.FCV_2901, ...parsed.FCV_2901 },
      FCV_2902: { ...DEFAULT_VALVES.FCV_2902, ...parsed.FCV_2902 },
      FCV_2903: { ...DEFAULT_VALVES.FCV_2903, ...parsed.FCV_2903 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("H2SStripper_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
     



  const [FIC_2809, setFIC_2809] = useState(() => {
   return Number(localStorage.getItem("FIC_2809")) || 0;
     });


  useEffect(() => {const savedValue = parseFloat(localStorage.getItem("FIC_2809")) || 0;
    setFIC_2809(savedValue);
  }, []);

      const FIC_2901 = FIC_2809 * 0.999;

    const [PT_2805, setPT_2805] = useState(() => {
   return Number(localStorage.getItem("PT_2805")) || 0;
     });
  useEffect(() => {const savedValue = parseFloat(localStorage.getItem("PT_2805")) || 0.03;
    setPT_2805(savedValue);
  }, []);

      const PT_2901 = PT_2805;

      const [TT_2805, setTT_2805] = useState(() => {
   return Number(localStorage.getItem("TT_2805")) || 0;
     });
  useEffect(() => {const savedValue = parseFloat(localStorage.getItem("TT_2805")) || 0;
    setTT_2805(savedValue);
  }, []);

      const TT_2901 = TT_2805;

  const isXV_2904Open = valves?.XV_2904 === false;
  const isXV_2901Open = valves?.XV_2901 === false;

  const FIC_2901a = isXV_2904Open ? 3 : 0;

  const PT_2909 = isXV_2904Open ? 0.9 : 0.04;
  const TT_2909 = isXV_2904Open ? 34 : 25;

  const FIC_2902 = isXV_2901Open ? (6 * (valveData?.FCV_2901?.opening || 0)/100) : 0;


  // ======================================================
// REAL REFINERY CHEMICAL SYSTEM MODEL - pH_2901
// ======================================================

// Inputs
const valveOpening = Number(valveData?.FCV_2901?.opening ?? 0);
const flow2901 = Number(FIC_2901 ?? 0);

// ======================================================
// 1. PROCESS MEMORY (DEAD TIME / LAG)
// ======================================================
const prevFlow = Number(localStorage.getItem("prev_FIC_2901") ?? flow2901);
const prevPH = Number(localStorage.getItem("prev_pH_2901") ?? 7);

// Save for next cycle
useEffect(() => {
  localStorage.setItem("prev_FIC_2901", flow2901);
}, [flow2901]);

// ======================================================
// 2. PROCESS CONDITIONS
// ======================================================
const activeFlow = flow2901 > 0.5;
const flowIncreasing = flow2901 > prevFlow;

// ======================================================
// 3. BASE CHEMISTRY MODEL
// ======================================================
// In real systems:
// - higher flow → more produced water activity → pH rises toward alkaline (9.5)
// - low flow → system relaxes toward neutral/acidic baseline

const maxPH = 9.5;
const minPH = 0.02;

// Flow normalization (smooth curve, NOT linear)
const flowFactor = Math.tanh(flow2901 / 10); // 0 → 1 smoothly

let basePH = minPH + flowFactor * (maxPH - minPH);

// ======================================================
// 4. FLOW DYNAMICS (INERTIA + RESPONSE DELAY)
// ======================================================
let dynamicPH = prevPH;

// If flow is increasing → system reacts upward
if (activeFlow) {

  const acceleration = flowIncreasing ? 0.08 : 0.03;

  dynamicPH =
    prevPH +
    (basePH - prevPH) * acceleration;

} else {
  // system decay back toward neutral when no flow
  dynamicPH = prevPH * 0.92;
}

// ======================================================
// 5. VALVE CHEMICAL EFFECT (NEUTRALIZATION / DOSING)
// ======================================================
if (isXV_2901Open) {

  const opening = Math.max(0, Math.min(100, valveOpening));

  // Non-linear valve effect (realistic control valve behavior)
  const valveEffect = Math.pow(opening / 100, 1.5);

  // Higher opening → stronger suppression of alkalinity
  dynamicPH =
    dynamicPH * (1 - valveEffect) +
    minPH * valveEffect;
}

// ======================================================
// 6. TURBULENCE / PROCESS NOISE (REAL PLANT FLUCTUATION)
// ======================================================
const noise = (Math.random() - 0.5) * 0.05;
dynamicPH += noise;

// ======================================================
// 7. SAFETY CLAMPING
// ======================================================
if (dynamicPH < minPH) dynamicPH = minPH;
if (dynamicPH > maxPH) dynamicPH = maxPH;

// ======================================================
// FINAL OUTPUT
// ======================================================
const pH_2901 = Number(dynamicPH.toFixed(2));

// ======================================================
// SAVE STATE
// ======================================================
useEffect(() => {
  localStorage.setItem("pH_2901", pH_2901);
}, [pH_2901]);


const TT_2902 = TT_2901 * 0.998;

const PT_2902 = PT_2901 * 0.887;

const PT_2903 = PT_2902 * 0.687;

const TT_2904 = TT_2902 * 0.998;

const PT_2904 = PT_2902 * 0.787;



// ================= CONTEXT =================
const { pumpData } = useContext(PumpContext);

// ================= PUMPS =================
const isPumpAOn = pumpData?.["P-290A"]?.running ?? false;
const isPumpBOn = pumpData?.["P-290B"]?.running ?? false;

const runningPumps = [isPumpAOn, isPumpBOn].filter(Boolean).length;

// ================= VALVE =================
const valveOpeningRaw = Number(valveData?.FCV_2902?.opening ?? 0);

// clamp 0–100
const valveOpenings = Math.max(0, Math.min(100, valveOpeningRaw));

// ================= BASE FLOW =================
const FIC_2903a = 60; // max design flow

// =====================================================
// FLOW LOGIC (CORRECTED)
// =====================================================

// total system flow (NOT dependent on pump count)
const targetFlow =
  runningPumps > 0
    ? FIC_2903a * (valveOpenings / 100)
    : 0;

// optional: flow sharing per pump (for future use)
const flowPerPump =
  runningPumps > 0
    ? targetFlow / runningPumps
    : 0;

// =====================================================
// SMOOTH DCS RESPONSE (CRITICAL)
// =====================================================
const [FIC_2903, setFIC_2903] = useState(() => {
   return Number(localStorage.getItem("FIC_2903")) || 0;
     });

useEffect(() => {
  const interval = setInterval(() => {
    setFIC_2903(prev => {
      const next = prev + (targetFlow - prev) * 0.12; // smooth ramp
      return isNaN(next) ? 0 : next;
    });
  }, 50);

  return () => clearInterval(interval);
}, [targetFlow]);

// =====================================================
// SAVE TAG
// =====================================================
useEffect(() => {
  localStorage.setItem("FIC_2903", FIC_2903);
}, [FIC_2903]);

const PRESSURE_MAP = [
  { opening: 0, value: 0.03 },
  { opening: 20, value: 0.3 },
  { opening: 40, value: 0.7 },
  { opening: 60, value: 1.0 },
  { opening: 80, value: 1.2 },
  { opening: 100, value: 1.3 },
];

// =======================================
// INTERPOLATION FUNCTION (REQUIRED)
// =======================================
const interpolate = (x, map) => {
  for (let i = 0; i < map.length - 1; i++) {
    const p1 = map[i];
    const p2 = map[i + 1];

    if (x >= p1.opening && x <= p2.opening) {
      const ratio =
        (x - p1.opening) / (p2.opening - p1.opening);

      return p1.value + ratio * (p2.value - p1.value);
    }
  }

  return map[map.length - 1].value;
};

// =======================================
// PRESSURE LOGIC FOR P-290A/B (FIXED)
// =======================================

// Valve + Pump Conditions
const isXV2902Open = valves?.XV_2902 === false;
const anyPumpRunning = runningPumps > 0;

// =======================================
// TARGET PRESSURES
// =======================================

let targetSuctionPressure = 0;
let targetDischargePressure = 0;

if (!isXV2902Open || !anyPumpRunning) {
  // Valve closed or pumps off
  targetSuctionPressure = 0;
  targetDischargePressure = 0.03;
} else {
  // SUCTION PRESSURE (drops with flow)
  targetSuctionPressure =
    0.6 - (FIC_2903 / 60) * 0.3; // ~0.6 → 0.3 MPa

  // DISCHARGE PRESSURE (based on valve opening)
  targetDischargePressure = interpolate(valveOpenings, PRESSURE_MAP);
}

// =======================================
// SMOOTH DCS RESPONSE (STATE BASED)
// =======================================

const [PT_2903_state, setPT_2903] = useState(() => {
   return Number(localStorage.getItem("PT_2903_state")) || 0;
     });


const [PT_2905_state, setPT_2905] = useState(() => {
   return Number(localStorage.getItem("PT_2905_state")) || 0;
     });


useEffect(() => {
  const interval = setInterval(() => {

    setPT_2903(prev =>
      prev + (targetSuctionPressure - prev) * 0.08
    );

    setPT_2905(prev =>
      prev + (targetDischargePressure - prev) * 0.08
    );

  }, 200);

  return () => clearInterval(interval);

}, [targetSuctionPressure, targetDischargePressure]);


const PT_2905 = Number(PT_2905_state.toFixed(3));



// =======================================
// TEMPERATURE LOGIC FOR P-290A/B
// =======================================

const MAX_TEMP = 80;
const AMBIENT_TEMP = 25;

// =======================================
// TARGET TEMPERATURES
// =======================================

let targetSuctionTemp = AMBIENT_TEMP;
let targetDischargeTemp = AMBIENT_TEMP;

// === CASE 1: OFF / CLOSED ===
if (!isXV2902Open || !anyPumpRunning) {

  targetSuctionTemp = AMBIENT_TEMP;
  targetDischargeTemp = AMBIENT_TEMP + 1;

}

// === CASE 2: RUNNING ===
else {

  // Suction temp slightly drops with higher flow
  targetSuctionTemp =
    TT_2902 - (FIC_2903 / 60) * 2; // small drop

  // Discharge temp slightly increases due to pump energy
  targetDischargeTemp =
    targetSuctionTemp + 2 + (valveOpenings / 100) * 3;

}

// Clamp to max
targetSuctionTemp = Math.max(AMBIENT_TEMP, Math.min(MAX_TEMP, targetSuctionTemp));
targetDischargeTemp = Math.max(AMBIENT_TEMP, Math.min(MAX_TEMP, targetDischargeTemp));

// =======================================
// SMOOTH RESPONSE (DCS STYLE)
// =======================================


const [TT_2903_state, setTT_2903] = useState(() => {
   return Number(localStorage.getItem("TT_2903_state")) || 0;
     });

const [TT_2905_state, setTT_2905] = useState(() => {
   return Number(localStorage.getItem("TT_2905_state")) || 0;
     });

useEffect(() => {

  const interval = setInterval(() => {

    setTT_2903(prev =>
      prev + (targetSuctionTemp - prev) * 0.05
    );

    setTT_2905(prev =>
      prev + (targetDischargeTemp - prev) * 0.05
    );

  }, 100);

  return () => clearInterval(interval);

}, [targetSuctionTemp, targetDischargeTemp]);

// Final values
const TT_2903 = Number(TT_2903_state.toFixed(2));
const TT_2905 = Number(TT_2905_state.toFixed(2));




// =======================================
// XV-2903 SYSTEM (FLOW / PRESSURE / TEMP)
// =======================================

const isXV_2903Open = valves?.XV_2903 === false;

// ================= INITIALIZE FROM STORAGE =================
const [FIC_2904, setFIC_2904] = useState(() =>
  Number(localStorage.getItem("FIC_2904") ?? 0)
);

const [PT_2906, setPT_2906] = useState(() =>
  Number(localStorage.getItem("PT_2906") ?? 0.03)
);

const [TT_2906, setTT_2906] = useState(() =>
  Number(localStorage.getItem("TT_2906") ?? 26)
);

// ================= TARGET VALUES =================

// FLOW
const targetFlowGas = isXV_2903Open ? 25 : 0;

// ================= PRESSURE (FIXED) =================

const basePressure = 0.03;
const maxPressure = 1.3;

let targetPressureGas = basePressure;

if (isXV_2903Open) {

  // DIRECT valve influence (NO stale dependency)
  targetPressureGas =
    basePressure +
    (maxPressure - basePressure) *
    (valveOpenings / 100);

}

// clamp
targetPressureGas = Math.max(basePressure, Math.min(maxPressure, targetPressureGas));

// ================= TEMPERATURE =================
const targetTempGas = isXV_2903Open ? 45 : 26;

// ================= FAST RESPONSE =================
useEffect(() => {

  const interval = setInterval(() => {

    // FLOW
    setFIC_2904(prev => {
      const error = targetFlowGas - prev;
      return Number((prev + error * 0.3).toFixed(2));
    });

    // PRESSURE (NOW GUARANTEED TO CHANGE)
    setPT_2906(prev => {
      const error = targetPressureGas - prev;
      return Number((prev + error * 0.5).toFixed(3));
    });

    // TEMPERATURE
    setTT_2906(prev => {
      const error = targetTempGas - prev;
      return Number((prev + error * 0.2).toFixed(2));
    });

  }, 100);

  return () => clearInterval(interval);

}, [targetFlowGas, targetPressureGas, targetTempGas, valveOpenings]);


// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("FIC_2904", FIC_2904);
}, [FIC_2904]);

useEffect(() => {
  localStorage.setItem("PT_2906", PT_2906);
}, [PT_2906]);

useEffect(() => {
  localStorage.setItem("TT_2906", TT_2906);
}, [TT_2906]);







// ================= H2S ANALYZER (AIT_2901) =================

// Make sure WellContext provides this
const { wellData } = useContext(WellContext);

// ---------- FUNCTION: Get H2S fraction from a well ----------
const getH2SFraction = (well) => {
  if (!well) return 0;

  const percent =
    Number(well.percentages?.["Hydrogen sulfide (H2S)"]) || 0;

  const discovered = Number(well.discovered) || 0;
  const totalProduction = 10000; // same as faceplate

  const availableReserve = discovered - totalProduction;

  if (availableReserve <= 0) return 0;

  return (percent / 100) * availableReserve;
};

// ---------- VALVE STATUS (false = OPEN) ----------
const isNK1Open = valves?.XV_10103 === false;
const isNK2Open = valves?.XV_10203 === false;
const isNK3Open = valves?.XV_10303 === false;

// ---------- APPLY LOGIC ----------
const NK1_H2S = isNK1Open ? getH2SFraction(wellData?.NK1)/800 : 0;
const NK2_H2S = isNK2Open ? getH2SFraction(wellData?.NK2)/800 : 0;
const NK3_H2S = isNK3Open ? getH2SFraction(wellData?.NK3)/800 : 0;

// ---------- COUNT ACTIVE WELLS ----------
const activeWells =
  (isNK1Open ? 1 : 0) +
  (isNK2Open ? 1 : 0) +
  (isNK3Open ? 1 : 0);

// ---------- FINAL AIT VALUE ----------
let rawAIT_2901 = 0;

if (activeWells > 0) {
  rawAIT_2901 =
    (NK1_H2S + NK2_H2S + NK3_H2S) / activeWells;
}

// ---------- SMOOTHING (REAL ANALYZER BEHAVIOR) ----------
const [AIT_2901, setAIT_2901] = useState(() => {
  const saved = localStorage.getItem("AIT_2901");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {
  const interval = setInterval(() => {
    setAIT_2901(prev => {
      const next = prev + (rawAIT_2901 - prev) * 0.15; // fast but stable
      return Number(next.toFixed(0));
    });
  }, 100); // responsive (no lag issue)

  return () => clearInterval(interval);
}, [rawAIT_2901]);

// ---------- OPTIONAL SAVE ----------
useEffect(() => {
  localStorage.setItem("AIT_2901", AIT_2901);
}, [AIT_2901]);







// =======================================================
// 🔥 HEAT EXCHANGER — FULLY ENGINEERED MODEL (COUPLED)
// =======================================================

// ================= VALVES =================
const waterValve = Number(valveData?.FCV_2902?.opening || 0);
const gasValve = Number(valveData?.FCV_2903?.opening || 0);

// ================= FLOWS (VALVE-CONTROLLED) =================
const gasFlow = (Number(FIC_2904 || 0) * gasValve) / 100;
const waterFlow = (Number(FIC_2903 || 0) * waterValve) / 100;

// ================= INLETS =================
const gasInTemp = Number(TT_2906 || 30);
const gasInPressure = Number(PT_2906 || 0.03);

const waterInTemp = Number(TT_2905 || 80);
const waterInPressure = Number(PT_2905 || 0.03);

// ================= SAFETY =================
const safeGasFlow = Math.max(gasFlow, 0.1);
const safeWaterFlow = Math.max(waterFlow, 0.1);

// =======================================================
// 🔥 1. GAS SIDE CALIBRATED TEMPERATURE MODEL
// =======================================================

// engineered to match:
// Flow 25 → ~90°C
// Flow 5  → ~180°C

const exponent = 0.756;

const gasTempRise =
  25 * Math.pow(25 / safeGasFlow, exponent);

let targetGasTemp = gasInTemp + gasTempRise;

// clamp realistic limits
targetGasTemp = isXV_2903Open ? Math.max(70, Math.min(200, targetGasTemp)) : 22;

// =======================================================
// 🔥 2. HEAT DUTY CALCULATION (REAL PHYSICS)
// =======================================================

// assume Cp values (simplified but realistic)
const Cp_gas = 2.2;     // kJ/kg.K
const Cp_water = 4.18;  // kJ/kg.K

// assume density scaling (for simulation only)
const gasMassFlow = safeGasFlow * 0.8;
const waterMassFlow = safeWaterFlow * 1.0;

// heat absorbed by gas
const Q_gas =
  gasMassFlow * Cp_gas * (targetGasTemp - gasInTemp);

// =======================================================
// 🔥 3. WATER SIDE (ENERGY BALANCE — COUPLED)
// =======================================================

// water loses same heat gained by gas
let targetWaterTemp =
  waterInTemp - (Q_gas / (waterMassFlow * Cp_water));

// apply realism clamp
targetWaterTemp = Math.max(25, targetWaterTemp);

// =======================================================
// 🔥 4. FLOW EFFECT CORRECTION (CRITICAL)
// =======================================================

// water flow ↑ → stronger cooling
const waterBoost = Math.min(safeWaterFlow / 50, 1.2);

// gas flow ↓ → hotter gas (already handled above)

// apply coupling correction
targetWaterTemp =
  waterInTemp -
  (waterInTemp - targetWaterTemp) * waterBoost;

// =======================================================
// 🔥 5. PRESSURE MODELS (TEMP-DEPENDENT)
// =======================================================

// GAS PRESSURE rises with temp
let targetGasPressure =
  gasInPressure +
  (targetGasTemp - gasInTemp) * 0.01;

targetGasPressure = Math.max(0.03, Math.min(2.2, targetGasPressure));

// WATER PRESSURE drops slightly with flow
let targetWaterPressure =
  waterInPressure - (safeWaterFlow / 100) * 0.08;

targetWaterPressure = Math.max(0.03, targetWaterPressure);

// =======================================================
// 🔥 6. FLOW OUT (SMALL LOSSES)
// =======================================================

const targetGasFlowOut = gasFlow * 0.98;
const targetWaterFlowOut = waterFlow * 0.99;

// =======================================================
// 🔁 FAST DYNAMIC RESPONSE (NO LAG)
// =======================================================

const [TT_2907, setTT_2907] = useState(90);
const [PT_2907, setPT_2907] = useState(0.1);
const [FIC_2909, setFIC_2909] = useState(0);

const [TT_2908, setTT_2908] = useState(40);
const [PT_2908, setPT_2908] = useState(0.1);

const [FIC_2908, setFIC_2908] = useState(() => {
  const saved = localStorage.getItem("FIC_2908");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {

  const interval = setInterval(() => {

    // ===== GAS =====
    setTT_2907(prev => {
      const next = prev + (targetGasTemp - prev) * 0.3;
      return Number(next.toFixed(2));
    });

    setPT_2907(prev => {
      const next = prev + (targetGasPressure - prev) * 0.3;
      return Number(next.toFixed(3));
    });

    setFIC_2909(prev => {
      const next = prev + (targetGasFlowOut - prev) * 0.35;
      return Number(next.toFixed(2));
    });

    // ===== WATER =====
    setTT_2908(prev => {
      const next = prev + (targetWaterTemp - prev) * 0.25;
      return Number(next.toFixed(2));
    });

    setPT_2908(prev => {
      const next = prev + (targetWaterPressure - prev) * 0.3;
      return Number(next.toFixed(3));
    });

    setFIC_2908(prev => {
      const next = prev + (targetWaterFlowOut - prev) * 0.35;
      return Number(next.toFixed(2));
    });

  }, 100);

  return () => clearInterval(interval);

}, [
  targetGasTemp,
  targetGasPressure,
  targetGasFlowOut,
  targetWaterTemp,
  targetWaterPressure,
  targetWaterFlowOut
]);

// =======================================================
// 💾 SAVE TO LOCAL STORAGE
// =======================================================

useEffect(() => {
  localStorage.setItem("TT_2907", TT_2907);
  localStorage.setItem("PT_2907", PT_2907);
  localStorage.setItem("FIC_2909", FIC_2909);

  localStorage.setItem("TT_2908", TT_2908);
  localStorage.setItem("PT_2908", PT_2908);
  localStorage.setItem("FIC_2908", FIC_2908);
}, [TT_2907, PT_2907, FIC_2909, TT_2908, PT_2908, FIC_2908]);


      useEffect(() => {
                    localStorage.setItem("FIC_2908", FIC_2908);
                  }, [FIC_2908]);
      useEffect(() => {
               localStorage.setItem("PT_2908", PT_2908);
               }, [PT_2908]);



const FIC_2910 = FIC_2909 - (FIC_2809 * 0.001);

      useEffect(() => {
               localStorage.setItem("FIC_2910", FIC_2910);
               }, [FIC_2910]);






// =======================================================
// 🧪 H2S STRIPPING MODEL — AIT_2902 (ENGINEERED)
// =======================================================

// ================= INPUTS =================
const pH = Number(pH_2901 || 7);
const gasTemp = Number(TT_2907 || 70);

// =======================================================
// 🔥 1. pH EFFICIENCY (GAUSSIAN PEAK @ 5.0)
// =======================================================

const pH_opt = 5.0;
const pH_width = 0.7;

const pH_eff =
  Math.exp(-Math.pow((pH - pH_opt) / pH_width, 2));

// clamp (avoid zero)
const pH_eff_clamped = Math.max(0.05, pH_eff);

// =======================================================
// 🔥 2. TEMPERATURE EFFICIENCY (PEAK @ 90°C)
// =======================================================

const temp_opt = 80;
const temp_width = 12;

const temp_eff =
  Math.exp(-Math.pow((gasTemp - temp_opt) / temp_width, 2));

// extra penalty for low temp (VERY IMPORTANT)
const lowTempPenalty =
  gasTemp < 70 ? (gasTemp / 70) : 1;

const temp_eff_corrected =
  temp_eff * lowTempPenalty;

// clamp
const temp_eff_clamped = Math.max(0.05, temp_eff_corrected);

// =======================================================
// 🔥 3. OVERALL STRIPPING EFFICIENCY
// =======================================================

const efficiency =
  pH_eff_clamped * temp_eff_clamped * 10;

// =======================================================
// 🔥 4. H2S CONCENTRATION MODEL
// =======================================================

// base untreated H2S level
const baseH2S = 120;

// inverse relationship
let targetH2S =
  baseH2S / efficiency;

// clamp realistic range
targetH2S = isXV_2903Open ? Math.max(10, Math.min(250, targetH2S)) : AIT_2901;

// =======================================================
// 🔁 5. DYNAMIC RESPONSE (FAST & STABLE)
// =======================================================

const [AIT_2902, setAIT_2902] = useState(50);

useEffect(() => {

  const interval = setInterval(() => {

    setAIT_2902(prev => {
      const next =
        prev + (targetH2S - prev) * 0.25; // fast but stable

      return Number(next.toFixed(2));
    });

  }, 150);

  return () => clearInterval(interval);

}, [targetH2S]);

// =======================================================
// 💾 SAVE
// =======================================================

useEffect(() => {
  localStorage.setItem("AIT_2902", AIT_2902);
}, [AIT_2902]);




const [showChart, setShowChart] = useState(false);
const [showTrendChart, setShowTrendChart] = useState(false);


  return (
    <div className="H2SStripper-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "244px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "0px 171px"
      }}>
        HYDROGEN SULFIDE (H2S) STRIPPER
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2901 */}
      <Valve
        className="XV-2901"
        tag="XV_2901"
        x={291}
        y={426}
        isClosed={valves.XV_2901}
        toggle={toggleValve}
      />

      {/* XV-2902 */}
      <Valve
        className="XV-2902"
        tag="XV_2902"
        x={601}
        y={497}
        isClosed={valves.XV_2902}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-2903 */}
      <Valve
        className="XV-2903"
        tag="XV_2903"
        x={1062}
        y={350}
        isClosed={valves.XV_2903}
        toggle={toggleValve}
        r={90}
      />

      
      
      {/* XV-2904 */}
      <Valve
        className="XV-2904"
        tag="XV_2904"
        x={110}
        y={260}
        isClosed={valves.XV_2904}
        toggle={toggleValve}
        r={0}
      />

      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2901 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2901"
          style={{ position: "absolute", left: 330, top: 416}}  onClick={() => openPanel("FCV_2901")}>
          
          <defs>
            <linearGradient id="metal_2901">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2901)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2901)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2902 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2902"
          style={{ position: "absolute", left: 959, top: 385, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2902")}>
          
          <defs>
            <linearGradient id="metal_2902">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2902)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2902)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2903 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2903"
          style={{ position: "absolute", left: 885, top: 189 }}  onClick={() => openPanel("FCV_2903")}>
          
          <defs>
            <linearGradient id="metal_2903">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2903)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2903)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= H2S EFFICIENCY STRIPPING CURVE ================= */}
          {showChart && (
            <StrippingEfficiencyChart
              tag="AIT_2902"
              currentPH={pH_2901}
              currentTemp={TT_2907}
              close={() => setShowChart(false)}
            />
          )}


          {showChart && (
              <StrippingMultivariableTrendChart
                close={() => setShowChart(false)}
              />
            )}



          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2901?.opening || 0)}
        
        x={357}
        y={455}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2902?.opening || 0)}
        x={950}
        y={401}
      />
      <ValveOutput
        value={Number(valveData?.FCV_2903?.opening || 0)}
        x={912}
        y={225}
      />


      <Transmitter
          tag="FIC-2901"
          value={FIC_2901}
          x={263}
          y={556}
          unit="LPM"
          max={80}
          HH={70}
          H={60}
          L={5}
          LL={2}
          c="lime"
          description="FLOWRATE OF WATER TO SOUR WATER STRIPPER."
        />

      <Transmitter
          tag="PT-2901"
          value={PT_2901}
          x={173}
          y={556}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF WATER TO SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="PT-2902"
          value={PT_2902}
          x={520}
          y={222}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF WATER AT FLASH ZONE OF SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="PT-2904"
          value={PT_2904}
          x={651}
          y={153}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF WATER AT OVERHEAD OF SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="PT-2903"
          value={PT_2903}
          x={694}
          y={324}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF WATER AT BOTTOM LEVEL OF SOUR WATER STRIPPER."
        />
      
      <Transmitter
          tag="PT-2909"
          value={PT_2909}
          x={283}
          y={286}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SULFURIC ACID OR HYDROGEN CHLORIDE INSIDE ACID STORAGE TANK."
        />
        
      <Transmitter
          tag="TT-2901"
          value={TT_2901}
          x={343}
          y={556}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF WATER TO SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="TT-2902"
          value={TT_2902}
          x={520}
          y={260}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF WATER AT FLASH ZONE OF SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="TT-2904"
          value={TT_2904}
          x={653}
          y={180}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF WATER AT OVERHEAD OF SOUR WATER STRIPPER."
        />
      <Transmitter
          tag="TT-2903"
          value={TT_2903}
          x={694}
          y={360}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF WATER AT BOTTOM LEVEL OF SOUR WATER STRIPPER."
        />
      
      <Transmitter
          tag="TT-2909"
          value={TT_2909}
          x={283}
          y={328}
          unit="°C"
          max={50}
          HH={40}
          H={35}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF SULFURIC ACID OR HYDROGEN CHLORIDE INSIDE ACID STORAGE TANK."
        />

      <Transmitter
          tag="FIC-2901a"
          value={FIC_2901a}
          x={13}
          y={256}
          unit="LPM"
          max={10}
          HH={9}
          H={8}
          L={1}
          LL={0.5}
          c="transparent"
          description="FLOWRATE OF SULFURIC ACID OR HYDROGEN CHLORIDE INTO ACID STORAGE TANK."
        />
      <Transmitter
          tag="FIC-2902"
          value={FIC_2902}
          x={283}
          y={488}
          unit="LPM"
          max={15}
          HH={13}
          H={11}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF SULFURIC ACID OR HYDROGEN CHLORIDE OUT OF ACID STORAGE TANK FOR pH REGULATION OF PRODUCED WATER"
        />
      <Transmitter
          tag="FIC-2903"
          value={[FIC_2903]}
          x={928}
          y={358}
          unit="LPM"
          max={70}
          HH={60}
          H={50}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE"
        />
      <Transmitter
          tag="pH-2901"
          value={pH_2901}
          x={463}
          y={398}
          unit=" "
          max={11}
          HH={9}
          H={8}
          L={1}
          LL={0.5}
          c="lime"
          description="pH OF PRODUCED WATER AND DOSING EFFECT BY SULFURIC ACID OR HYDROGEN CHLORIDE FROM OF ACID STORAGE TANK"
        />

        <Transmitter
          tag="PT-2905"
          value={PT_2905}
          x={928}
          y={442}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE"
        />

        <Transmitter
          tag="TT-2905"
          value={TT_2905}
          x={928}
          y={483}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE"
        />

        <Transmitter
          tag="PT-2906"
          value={PT_2906}
          x={1085}
          y={442}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF FUEL GAS LINE FOR STRIPPING OF H2S IN SOUR WATER STIPPER"
        />

        <Transmitter
          tag="TT-2906"
          value={TT_2906}
          x={1085}
          y={485}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF FUEL GAS LINE FOR STRIPPING OF H2S IN SOUR WATER STIPPER"
        />

        <Transmitter
          tag="FIC-2904"
          value={[FIC_2904]}
          x={1165}
          y={485}
          unit="SCF/S"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE"
        />
       
        <Transmitter
          tag="AIT-2901"
          value={[AIT_2901]}
          x={450}
          y={332}
          unit="ppmw"
          max={10000}
          HH={9600}
          H={9400}
          L={100}
          LL={5}
          c="lime"
          description="H2S CONCENTRATION OF PRODUCED WATER TO SOUR WATER STRIPPER"
        />
        <Transmitter
          tag="AIT-2902"
          value={[AIT_2902]}
          x={925}
          y={121}
          unit="ppmw"
          max={180}
          HH={150}
          H={40}
          L={5}
          LL={1}
          c="lime"
          description="H2S CONCENTRATION OF TREATED WATER OUT OF SOUR WATER STRIPPER TO SKIM PILE"
        />

        <Transmitter
          tag="PT-2907"
          value={PT_2907}
          x={1125}
          y={195}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF FUEL GAS LINE AT DISCHARGE OF HEAT EXCHANGER FOR STRIPPING OF H2S IN SOUR WATER STIPPER"
        />

        <Transmitter
          tag="TT-2907"
          value={TT_2907}
          x={1040}
          y={195}
          unit="°C"
          max={120}
          HH={115}
          H={100}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF FUEL GAS LINE AT DISCHARGE OF HEAT EXCHANGER FOR STRIPPING OF H2S IN SOUR WATER STIPPER"
        />

        <Transmitter
          tag="FIC-2909"
          value={[FIC_2909]}
          x={1192}
          y={235}
          unit="SCF/S"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF FUEL GAS LINE AT DISCHARGE OF HEAT EXCHANGER FOR STRIPPING OF H2S IN SOUR WATER STIPPER"
        />

        <Transmitter
          tag="PT-2908"
          value={PT_2908}
          x={1084}
          y={95}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE AND DISCHARGE OF HEAT EXCHANGER AFTER COOLING"
        />

        <Transmitter
          tag="TT-2908"
          value={TT_2908}
          x={1008}
          y={95}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE AND DISCHARGE OF HEAT EXCHANGER AFTER COOLING"
        />

        <Transmitter
          tag="FIC-2908"
          value={[FIC_2908]}
          x={1165}
          y={95}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER OUT OF SOUR WATER STRIPPER AT PUMP DISCHARGE LINE AND DISCHARGE OF HEAT EXCHANGER AFTER COOLING"
        />
        <Transmitter
          tag="FIC-2910"
          value={[FIC_2910]}
          x={725}
          y={81}
          unit="SCF/S"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF SOUR FUEL GAS LINE AT OVERHEAD OF SOUR WATER STIPPER TO FLARE HEADER"
        />


              
      <button
        className="efficiency-chart-btn"
        onClick={() => setShowChart(true)}
        style={{
          position: "absolute",
          left: "895px",   // adjust X
          top: "112px",    // adjust Y
          zIndex: 1000
        }}
      >
        <LineChart size={18} />
       
      </button>

       



          
    <LevelTransmitterIndicator
      tag="LT_2901"
      totalLevel={10000}
      inflows={[FIC_2901a]}
      outflows={[FIC_2902]}
      responseFactor={0.05}
      columnX={200}
      columnY={320}
      columnWidth={70}
      columnHeight={96}
      textX={100}
      textY={370}
      showFlow={true}
    />
          
    <LevelTransmitterIndicator
      tag="LT_2902"
      totalLevel={50000}
      inflows={[FIC_2901 + FIC_2902]}
      outflows={[FIC_2903]}
      responseFactor={0.05}
      columnX={565}
      columnY={383}
      columnWidth={90}
      columnHeight={78}
      textX={685}
      textY={390}
      showFlow={true}
    />


    <Pump
      tag="P-290A"
      x={839}
      y={490}
      rpm={1800}
      bladeCount={pumpData?.["P-290A"]?.bladeCount || 3}
      size={pumpData?.["P-290A"]?.size || 37}
      onClick={openPumpPanel}
    />

    <Pump
      tag="P-290B"
      x={842}
      y={587}
      rpm={1800}
      bladeCount={pumpData?.["P-290B"]?.bladeCount || 3}
      size={pumpData?.["P-290B"]?.size || 37}
      onClick={openPumpPanel}
    />


    </div>
  );
}

export default H2SStripper;